import { PlatformType } from '../../enums/platform-type.enum';

export class LogoutRequest {
	refreshToken: string;
	platform: PlatformType;
}
